// extracted by mini-css-extract-plugin
module.exports = {"single-image-container":"VendorImages_single-image-container__eSB7q"};